import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import LiveHelpOutlinedIcon from "@mui/icons-material/LiveHelpOutlined";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import LocalAirportOutlinedIcon from "@mui/icons-material/LocalAirportOutlined";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import BeenhereIcon from "@mui/icons-material/Beenhere";
import ListAltIcon from "@mui/icons-material/ListAlt";
import PaidIcon from "@mui/icons-material/Paid";
import CasinoIcon from "@mui/icons-material/Casino";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import StorefrontIcon from "@mui/icons-material/Storefront";
import InfoIcon from "@mui/icons-material/Info";
export const staticNavData = [
  {
    id: 0,
    icon: <HomeIcon />,
    text: "Dashboard",
    link: "/dashboard",
  },
  {
    id: 18,
    icon: <InfoIcon />,
    text: "About Us",
    link: "/aboutus",
  },
  {
    id: 17,
    icon: <StorefrontIcon />,
    text: "Market",
    link: "/market",
  },
  {
    id: 1,
    icon: <CasinoIcon />,
    text: "Slice and Dice",
    link: "/slice-and-dice",
  },
  {
    id: 2,
    icon: <BeenhereIcon />,
    text: "Arrival List",
    link: "/arrival-list",
  },
  {
    id: 3,
    icon: <ListAltIcon />,
    text: "Booking List",
    link: "/booking-list",
  },
  {
    id: 4,
    icon: <PaidIcon />,
    text: "Daily Transaction",
    link: "/daily-transaction",
  },
  {
    id: 5,
    icon: <PersonIcon />,
    text: "User Management",
    link: "/user-management",
  },
  {
    id: 6,
    icon: <AppRegistrationIcon />,
    text: "News Room",
    link: "/news-room",
  },
  {
    id: 7,
    icon: <LocalAirportOutlinedIcon />,
    text: "Trip Listing",
    link: "/trip-listing",
  },
  {
    id: 8,
    icon: <LiveHelpOutlinedIcon />,
    text: "FAQ Management",
    link: "/faq-management",
  },
  {
    id: 10,
    icon: <SubscriptionsIcon />,
    text: "Subscription",
    link: "/subscription",
  },
  {
    id: 11,
    icon: <PrivacyTipOutlinedIcon />,
    text: "Privacy and Policy",
    link: "/privacy-and-policy",
  },
  {
    id: 12,
    icon: <ArticleOutlinedIcon />,
    text: "Terms and Condition",
    link: "/terms-and-condition",
  },
  // {
  //   id: 13,
  //   icon: <ArticleOutlinedIcon />,
  //   text: "Flodesk",
  //   link: "/flo-desk",
  // },
  {
    id: 14,
    icon: <ManageAccountsIcon />,
    text: "Role Management",
    link: "/role-access",
  },
  {
    id: 15,
    icon: <ManageAccountsIcon />,
    text: "Featured Hotels",
    link: "/feature-hotels",
  },
  {
    id: 16,
    icon: <GroupAddIcon />,
    text: "Affiliates",
    link: "/affiliates",
  },
];
